import { isCurrentMonth, normalizeMonthName } from '@nextforce/api'
import { MonthlyEarnings, MonthlySummary } from '../../types'
import * as Response from './response'

export function convertMonthlySummary(
  monthlyEarningsResponse: Response.MonthlyEarnings
): MonthlyEarnings {
  return {
    monthlyEarningsTargetEnabled:
      monthlyEarningsResponse.monthly_earnings_target_enabled,
    averageMonthlyEarnings: monthlyEarningsResponse?.average_monthly_earnings,
    monthlySummaries: convertMonthlySummaries(
      monthlyEarningsResponse.monthly_summaries
    ),
  }
}

function convertMonthlySummaries(
  monthlySummariesResponse?: Response.MonthlySummary[]
): MonthlySummary[] {
  if (!monthlySummariesResponse) {
    return []
  }

  const monthlySummaries: MonthlySummary[] = monthlySummariesResponse.map(
    monthlySummary => {
      return {
        month: normalizeMonthName(monthlySummary.month),
        actual: {
          estimated: monthlySummary.actual.estimated,
          shiftCount: monthlySummary.actual.shift_count,
          hours: monthlySummary.actual.hours,
          earnings: monthlySummary.actual.earnings,
        },
        target: {
          shiftCount: monthlySummary.target.shift_count,
          hours: monthlySummary.target.hours,
          earnings: monthlySummary.target.earnings,
        },
        isCurrentMonth: isCurrentMonth(
          normalizeMonthName(monthlySummary.month)
        ),
        delta: monthlySummary.actual.earnings - monthlySummary.target.earnings,
        rate:
          monthlySummary.actual.hours > 0
            ? monthlySummary.actual.earnings / monthlySummary.actual.hours
            : 0,
      }
    }
  )

  return monthlySummaries
}
